

jQuery_T4NT(document).ready(function($) {
     
  
      $('#readmoreco').click(function(){
          $(this).parent().parent().toggleClass("active-full");
      });
	   
     /*
      $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
  
     
      setTimeout(function() {
       // alert("hi");
        $(".plyr__control").trigger('click');
        $(".plyr").trigger('click');
      },5000);
      */
});

